import { Component, OnInit, Inject, Output, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import * as moment from 'moment';

import { CommonService, AlertService, AdminService, LeadService, ProjectService, ProfileService } from '../../../_services/';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-request-delivery-dialog',
  templateUrl: './request-delivery-dialog.component.html',
  styleUrls: ['./request-delivery-dialog.component.scss']
})

export class RequestDeliveryDialogComponent implements OnInit {

  requestDeliveryForm:FormGroup;
  submitted:Boolean=false;
  showForm:Boolean = false;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  constructor(
    public dialogRef: MatDialogRef<RequestDeliveryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin : AdminService,
    private _toastr : ToastrService,
    private _lead : LeadService,
    private _project: ProjectService,
    private _profile : ProfileService
  ) { }

  ngOnInit() {
    
    this.requestDeliveryForm = this.fb.group({
      balance_paid : ["", []],
      first_name: ["", []],
      last_name:["",[]],
      client_contact:["",[]],
      additional_contact:["",[]],
      first_name2: ["", []],
      last_name2:["",[]],
      personal_role:["",[]],
      phone_number:["",[]],
      email:["",[]],
      person_same:["",[]],
      first_name3 : ["",[]],
      last_name3 : ["",[]],
      personal_role2 : ["",[]],
      phone_number3 : ["", []],
      email2 : ["",[]],
      pickup_delivery : ["",[]],
      personal_role3 : ["",[]],
      delivery_location : ["",[]],
      delivery_address : ["",[]],
      delivery_address2 : ["",[]],
      is_apartment : ["",[]],
      floor_description : ["",[]],
      multi_unit_building : ["",[]],
      certificate_insurance : ["",[]],
      doorman_super : ["",[]],
      delivery_team_required : ["",[]],
      designated_service : ["",[]],
      service_entrance_location : ["",[]],
      service_elevator_use : ["",[]],
      delivery_time_restriction : ["",[]],
      field_visit_performed : ["",[]],
      delivery_date_requested1 : ["",[]],
      delivery_date_requested2 : ["",[]],
      time_window : ["",[]],
      balance_amount : ["",[]],
      payment_eta : ["",[]],
      order_number1 : ["",[]],
      manufacturer : ["",[]],
      appliances_ordered : ["",[]],
      order_contains : ["",[]],
      uud_removal_requested : ["",[]],
      order_number2 : ["",[]],
      manufacturer2 : ["",[]],
      appliances_ordered2 : ["",[]],
      order_contains2 : ["",[]],
      uud_removal_requested2 : ["",[]],
      order_number3 : ["",[]],
      manufacturer3 : ["",[]],
      appliances_ordered3 : ["",[]],
      order_contains3 : ["",[]],
      uud_removal_requested3 : ["",[]]
    }) 
    
  }
  
  hideAddRequestDeliveryDialog(){
    this.dialogRef.close();
  }

  get fval() {
    return this.requestDeliveryForm.controls;
  }

  onFormSubmit():void {
    this.submitted = true;
   
    let form = this.requestDeliveryForm.value;
    form.uid = localStorage.getItem('uid');
    this._common.showLoader(true);
    const obj = {
      delivery_requested : 'Yes'
    }

    this._admin.editProject(obj,this.data.project_id).then(res => {
      this.subscription2 = this._lead.getContactDetail(this.data.owner_contact_id).subscribe(designer=>{
        //Code to send email
       this.subscription = this._project.getEmailRecipient('pm7_request_delivery_button').subscribe(emailRes=>{
        const emails = emailRes.docs.map(doc => doc.data());
        this.subscription3 = this._project.getSystemMode().subscribe(system=>{
          const systemData = system.map(item => item.payload.doc.data());
          const mode:any = systemData.filter(item=> item.hasOwnProperty("mode"));
          const designerEmail = designer.payload.data()['email'] ? designer.payload.data()['email'] :'';
          const cc = mode[0].mode==="Live" ? emails[0]['live_receipients']+','+designerEmail : emails[0]['dev_receipients']+','+emails[0]['dev_designers'];
          const mailBody = {
            to : 'rs@leichtnewyork.com',
            subject :`Ref #: ${this.data.accounting_ref} - ${this.data.contact_first_name} ${this.data.contact_last_name} - ${this.data.project_name} - ${this.data.step_number} - Delivery Request`,
            body : `Balance Paid: ${form.balance_paid}<br/>First Name: ${form.first_name}<br/> Last Name: ${form.last_name} <br/>Client Contact: ${form.client_contact} <br/>Additional Contact: ${form.additional_contact}<br/><br/><strong>Contact Information for Order Questions</strong><br/>First Name: ${form.first_name2}<br/> Last Name: ${form.last_name2}<br/>This person is the...: ${form.personal_role}<br/>Phone Number: ${form.phone_number}<br/>Email: ${form.email}<br/>This person is the same person receiving a Complimentary One Hour Call Ahead: ${form.person_same}<br/><br/><strong>Contact Information for One Hour Call Ahead</strong><br/>First Name: ${form.first_name3}<br/>Last Name: ${form.last_name3}<br/>This person is the... : ${form.personal_role2}<br/>Phone Number : ${form.phone_number3} <br/>Email: ${form.email2}<br/><br/><strong>Delivery Information</strong><br/>Delivery, Pickup or Pickup & Delivery: ${form.pickup_delivery}<br/> This is a(n)...: ${form.personal_role3}<br/>Delivery Location Within the Building: ${form.delivery_location}<br/>Delivery Address: ${form.delivery_address}<br/>Delivery Address - line 2 : ${form.delivery_address2}<br/>This is an apartment: ${form.is_apartment} <br/>Floor# or description: ${form.floor_description} <br/><br/><strong>Building Information</strong><br/>Is this in a multi-unit building?: ${form.multi_unit_building}<br/>Certificate of Insurance Required?: ${form.certificate_insurance}<br/>Doorman or Super Onsite?: ${form.doorman_super}<br/>ID Required of the Delivery Team?: ${form.delivery_team_required}<br/>Designated service entrance?: ${form.designated_service} <br/>Where is the service entrance located?: ${form.service_entrance_location}<br/>Required to use the service elevator?: ${form.service_elevator_use}<br/>Does the building have time restrictions for this delivery?: ${form.delivery_time_restriction}<br/>Has a field visit been performed and have all ordered pieces been verified to fit through doorways, hallways, elevators, etc?: ${form.field_visit_performed}<br/><br/><strong>Delivery date information</strong><br/>Delivery date requested 1: ${form.delivery_date_requested1} <br/>Delivery date requested 2: ${form.delivery_date_requested2}<br/>Time window: ${form.time_window}<br/>Balance amount in $: ${form.balance_amount}<br/>ETA for payment: ${form.payment_eta}<br/><br/><strong>Order Information #1</strong><br/>Order Number: ${form.order_number1}<br/>Manufacturer: ${form.manufacturer}<br/>Appliances ordered: ${form.appliances_ordered}<br/>This order contains crated goods: ${form.order_contains}<br/>Uncrating/Unpacking & Debris Removal Requested: ${form.uud_removal_requested}<br/><br/><strong>Order Information #2</strong><br/>Order Number: ${form.order_number2}<br/>Manufacturer: ${form.manufacturer2} <br/>Appliances ordered: ${form.appliances_ordered2}<br/>This order contains crated goods: ${form.order_contains2}<br/>Uncrating/Unpacking & Debris Removal Requested: ${form.uud_removal_requested2}<br/><br/><strong>Order Information #3</strong><br/>Order Number: ${form.order_number3}<br/>Manufacturer: ${form.manufacturer3} <br/>Appliances ordered: ${form.appliances_ordered3} <br/>This order contains crated goods: ${form.order_contains3} <br/>Uncrating/Unpacking & Debris Removal Requested: ${form.uud_removal_requested3}   <br/><br/>-<br/>Automated email sent via RS `,
            cc: cc
          }
          
          this._project.initEmail(mailBody).subscribe(res => {
            if(res){
              this._profile.updateRequestDelivery(this.data.project_id);
              this._common.showLoader(false);
              this._toastr.success("Request sent successfully!","",{ timeOut: 4000 });
              this.dialogRef.close();
            }
          },err=>{
            this._common.showLoader(false);
            this._toastr.error(`${err && err.error && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });
          }) 

        },
        err=>{
          this._common.showLoader(false);
          this._toastr.error(`${err && err.error && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });
  
        })

       },err=>{
        this._common.showLoader(false);
        this._toastr.error(`${err && err.error && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });
       })

      },err=>{
        this._common.showLoader(false);
        this._toastr.error(`${err && err.error && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });

      })
       
    },err=>{
      this._common.showLoader(false);
      this._toastr.success(`Something went wrong!`,"",{ timeOut: 4000 });
    })  
  }

  changeBalancePaid(event){
    if(event.target.value!=""){
      this.showForm = true;
    }
    else {
      this.showForm = false;
    }
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
    if(this.subscription3) this.subscription3.unsubscribe();
  }

}